/* Earths Water CRO modules (CRO J1). Behaviour only: all copy is rendered by the sections. */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width:760px)');
  function each(sel, root, fn) { Array.prototype.forEach.call((root || document).querySelectorAll(sel), fn); }
  function fmt(n) { return Math.round(n).toLocaleString('en-AU'); }

  /* HW3: tabs swap server-rendered panels */
  function initTabs(root) {
    each('[data-cro-tabs]', root, function (box) {
      if (box.dataset.ready) return; box.dataset.ready = 1;
      var btns = box.querySelectorAll('[data-tab]'), panels = box.querySelectorAll('[data-panel]');
      function go(i) {
        each('[data-tab]', box, function (b, j) { b.classList.toggle('on', j === i); b.setAttribute('aria-selected', j === i); b.tabIndex = j === i ? 0 : -1; });
        each('[data-panel]', box, function (p, j) { p.hidden = j !== i; });
      }
      box.addEventListener('click', function (e) { var b = e.target.closest('[data-tab]'); if (b) go(+b.dataset.tab); });
      box.addEventListener('keydown', function (e) {
        var b = e.target.closest('[data-tab]'); if (!b) return;
        var i = +b.dataset.tab, n = btns.length;
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); i = (i + (e.key === 'ArrowRight' ? 1 : n - 1)) % n; go(i); btns[i].focus(); }
      });
      go(0);
    });
  }

  /* HW4: step cards highlight */
  function initSteps(root) {
    each('[data-cro-steps]', root, function (box) {
      if (box.dataset.ready) return; box.dataset.ready = 1;
      box.addEventListener('click', function (e) { var b = e.target.closest('.hw4s'); if (!b) return; each('.hw4s', box, function (x) { x.classList.toggle('on', x === b); x.setAttribute('aria-pressed', x === b); }); });
    });
  }

  /* CO1 / CO3 calculators. Figures per brief: 74c a litre, $35 a cartridge, 350 L or 91 days, 500 ml bottle */
  function calc(ppl, lpd) {
    var d = ppl * lpd, L = d * 365, life = Math.min(350 / d, 91), yr = Math.ceil(365 / life);
    return { d: d, L: L, life: life, yr: yr, bottles: L / 0.5, spend: Math.round(L * 0.74 / 10) * 10, save: Math.max(0, Math.round((L * 0.74 - yr * 35) / 10) * 10) };
  }
  function initCalc(root) {
    each('[data-cro-calc]', root, function (box) {
      if (box.dataset.ready) return; box.dataset.ready = 1;
      var st = { ppl: +(box.dataset.ppl || 4), lpd: +(box.dataset.lpd || 2) };
      function out(key, val) { each('[data-out="' + key + '"]', box, function (el) { el.textContent = val; }); }
      function run() {
        var r = calc(st.ppl, st.lpd), wk = Math.round(r.life / 7);
        out('every', r.life >= 84 ? (box.dataset.t3m || '3 months') : (wk <= 1 ? 'week' : wk + ' weeks'));
        out('bottles', fmt(r.bottles));
        out('save', '$' + fmt(r.save));
        out('spend', '$' + fmt(r.spend));
        out('lpd', String(Math.round(r.d * 10) / 10));
        out('litres', fmt(r.L));
        out('spendx', '$' + fmt(r.L * 0.74));
        var plan = r.life >= 75 ? 'every 3 months' : (r.life >= 45 ? 'every 2 months' : 'every month');
        out('plan', plan);
      }
      box.addEventListener('click', function (e) {
        var b = e.target.closest('[data-v]'); if (!b) return; var g = b.closest('[data-key]'); if (!g) return;
        each('[data-v]', g, function (x) { x.classList.toggle('on', x === b); x.setAttribute('aria-pressed', x === b); });
        st[g.dataset.key] = parseFloat(b.dataset.v); run();
      });
      run();
    });
  }

  /* RW4: tick-any checklist */
  function initChecklist(root) {
    each('[data-cro-check]', root, function (box) {
      if (box.dataset.ready) return; box.dataset.ready = 1;
      var lines = []; try { lines = JSON.parse(box.dataset.lines || '[]').map(function (x) { return String(x).trim(); }); } catch (e) {}
      box.addEventListener('change', function (e) {
        var c = box.querySelectorAll('input:checked').length;
        each('.rw4n', box, function (n) { n.textContent = c; });
        each('[data-out="line"]', box, function (t) { if (lines[c]) t.textContent = lines[c]; });
        var l = e.target.closest('label'); if (l) l.classList.toggle('sel', e.target.checked);
      });
    });
  }

  /* RV carousels: arrows + hide arrows when nothing overflows */
  function initCarousels(root) {
    each('.cro .rv2s', root, function (sc) {
      var sec = sc.closest('.sec'); if (!sec || sec.dataset.ready) return; sec.dataset.ready = 1;
      function chk() { sec.classList.toggle('rv2-noov', sc.scrollWidth <= sc.clientWidth + 2); }
      each('.rv2a', sec, function (b) { b.addEventListener('click', function () { sc.scrollBy({ left: (+b.dataset.d) * sc.clientWidth * 0.85, behavior: 'smooth' }); }); });
      chk(); window.addEventListener('resize', chk);
    });
  }

  /* Footer menus: open on desktop, collapsible on mobile */
  function footerMode() {
    each('.cro .fcol', document, function (d) { if (!mq.matches) d.open = true; else if (!d.dataset.touched) d.open = false; });
  }
  function initFooter(root) {
    each('.cro .fcol summary', root, function (sm) {
      if (sm.dataset.ready) return; sm.dataset.ready = 1;
      sm.addEventListener('click', function (e) { if (!mq.matches) { e.preventDefault(); return; } sm.parentElement.dataset.touched = 1; });
    });
    footerMode();
  }

  /* SE1: contents links open their accordion */
  function initToc(root) {
    each('.cro .acc-toc a', root, function (l) {
      if (l.dataset.ready) return; l.dataset.ready = 1;
      l.addEventListener('click', function () { var d = document.querySelector(l.getAttribute('href')); if (d) d.open = true; });
    });
    if (location.hash) { var d = document.getElementById(location.hash.slice(1)); if (d && d.tagName === 'DETAILS') d.open = true; }
  }


  /* CM3: two-question filter finder; answers are server-rendered <template data-r="a|b"> */
  function initFinder(root) {
    each('[data-cro-finder]', root, function (box) {
      if (box.dataset.ready) return; box.dataset.ready = 1;
      var ans = {}, q = box.querySelectorAll('[data-q]');
      function f(n) { return box.querySelector('[data-f="' + n + '"]'); }
      box.addEventListener('click', function (e) {
        var b = e.target.closest('[data-q] [data-v]'); if (!b) return; var g = b.closest('[data-q]');
        each('[data-v]', g, function (x) { x.classList.toggle('on', x === b); x.setAttribute('aria-pressed', x === b); });
        ans[g.dataset.q] = b.dataset.v;
        var key = []; for (var i = 0; i < q.length; i++) { var v = ans[q[i].dataset.q]; if (!v) return; key.push(v); }
        var t = box.querySelector('template[data-r="' + key.join('|') + '"]'); if (!t) return;
        f('name').textContent = t.dataset.name; f('line').textContent = t.dataset.line;
        if (t.dataset.url) f('go').href = t.dataset.url;
        var im = f('img'); im.innerHTML = t.innerHTML; im.classList.toggle('has-img', !!t.innerHTML.trim());
      });
    });
  }

  /* SB1: delivery menu picks the selling plan on the cartridge page */
  function initSub(root) {
    each('[data-cro-sub]', root, function (card) {
      if (card.dataset.ready) return; card.dataset.ready = 1;
      var sel = card.querySelector('[data-plan]'), a = card.querySelector('a[data-base]'); if (!sel || !a) return;
      function go() { var v = sel.value; a.href = a.dataset.base + (v ? (a.dataset.base.indexOf('?') < 0 ? '?' : '&') + 'selling_plan=' + v : ''); }
      sel.addEventListener('change', go); go();
    });
  }

  /* #buy-box links: scroll to the theme's product form (buy box is the theme's own section) */
  function buyBox() { return document.getElementById('buy-box') || document.querySelector('product-info, .product__info'); }
  function toBuyBox(smooth) {
    var el = buyBox(); if (!el) return false;
    var hdr = document.querySelector('sticky-header, .header-section, header'); var off = hdr ? Math.min(hdr.getBoundingClientRect().height, 140) : 0;
    window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - off - 12, behavior: smooth ? 'smooth' : 'auto' });
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="#buy-box"]'); if (!a) return;
    if (toBuyBox(true)) e.preventDefault();
  });
  if (location.hash === '#buy-box') window.addEventListener('load', function () { toBuyBox(false); });


  /* Collection grid: our own Sort by menu (button + list; links work without JS) */
  function sortClose(w) { var b = w.querySelector('.cro-sortbtn'), l = w.querySelector('.cro-sortlist'); if (!b || !l) return; b.setAttribute('aria-expanded', 'false'); l.hidden = true; }
  function sortOpen(w) { var b = w.querySelector('.cro-sortbtn'), l = w.querySelector('.cro-sortlist'); b.setAttribute('aria-expanded', 'true'); l.hidden = false; l.style.left = ''; l.style.right = ''; var r = l.getBoundingClientRect(); if (r.left < 8) { l.style.left = '0'; l.style.right = 'auto'; } var c = l.querySelector('[aria-selected="true"] a') || l.querySelector('a'); if (c) c.focus(); }
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest) return;
    var btn = t.closest('.cro-sortbtn');
    document.querySelectorAll('[data-cro-sort]').forEach(function (w) { if (!btn || !w.contains(btn)) sortClose(w); });
    if (btn) { var w = btn.closest('[data-cro-sort]'); if (btn.getAttribute('aria-expanded') === 'true') sortClose(w); else sortOpen(w); return; }
    var a = t.closest('.cro-sortlist a[data-v]'); if (!a) return;
    e.preventDefault();
    var u = new URL(location.href); u.searchParams.set('sort_by', a.dataset.v); u.searchParams.delete('page'); location.href = u.toString();
  });
  document.addEventListener('keydown', function (e) {
    var w = e.target.closest && e.target.closest('[data-cro-sort]'); if (!w) return;
    var l = w.querySelector('.cro-sortlist'); if (!l || l.hidden) return;
    var as = [].slice.call(l.querySelectorAll('a')), i = as.indexOf(document.activeElement);
    if (e.key === 'Escape') { sortClose(w); w.querySelector('.cro-sortbtn').focus(); e.preventDefault(); }
    else if (e.key === 'ArrowDown') { (as[i + 1] || as[0]).focus(); e.preventDefault(); }
    else if (e.key === 'ArrowUp') { (as[i - 1] || as[as.length - 1]).focus(); e.preventDefault(); }
    else if (e.key === 'Tab') sortClose(w);
  });

  function init(root) { initTabs(root); initSteps(root); initCalc(root); initChecklist(root); initCarousels(root); initFooter(root); initToc(root); initFinder(root); initSub(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  window.addEventListener('resize', footerMode);
  /* theme editor: re-init a section when it reloads */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
